import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { Generator } from "../utils/backend-types";

type FetchGeneratorsArgs = {
  siteId?: number;
  personId?: number;
};

export const generatorsQueries = {
  all: () => ["generators"] as const,
  list: ({ siteId, personId }: FetchGeneratorsArgs = {}) => {
    return queryOptions<Array<Generator>>({
      queryKey: [...generatorsQueries.all(), { siteId, personId }],
      queryFn:
        personId || siteId
          ? () => fetchGenerators({ siteId, personId })
          : skipToken,
      staleTime: 10000
    });
  }
};

export function useGenerators(
  args?: FetchGeneratorsArgs,
  options?: Partial<UseQueryOptions<Array<Generator>>>
) {
  return useQuery({
    ...generatorsQueries.list(args),
    ...options
  });
}

async function fetchGenerators({ siteId, personId }: FetchGeneratorsArgs) {
  const response = await api.get<Array<Generator>>(
    urls.api.generators({ siteId, personId })
  );
  return response.data;
}
